import { Box, Spinner } from '@zillow/constellation-10';

export type SpinnerContainerProps = {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  height?: string;
};

const SpinnerContainer = ({ size = 'md', height = '200px' }: SpinnerContainerProps) => (
  <Box
    css={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '800',
      height: height,
    }}
    data-testid="spinnerContainer"
  >
    <Spinner size={size} />
  </Box>
);

export default SpinnerContainer;
